import { QueryClient } from '@tanstack/react-query';

// Central QueryClient with sensible defaults for caching and UX
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Treat data as fresh for 5 minutes to minimize repeat calls
      staleTime: 5 * 60 * 1000,
      // Keep cached data in memory for 15 minutes
      gcTime: 15 * 60 * 1000,
      // Avoid noisy refetches when tab gains focus; tune per-hook if needed
      refetchOnWindowFocus: false,
      // Retry once on transient errors
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
